module.exports = __webpack_public_path__ + "static/media/current-status-recording.942651db.jpg";